<script>
</script>

<header class="header">
  <h1>Snap Valley</h1>
</header>

<style>
  .header {
    width: 100%;
    padding: 10px 20px;
    background-color: #f33535;
    color: #fff;
  }

  h1 {
    margin: 5px 10px;
    font-weight: 900;
  }
</style>
